import { Grid } from '@mui/material';
import * as React from 'react';
import { Container, Label } from 'semantic-ui-react';
import { IHelper, Helper } from '../services';
import styles from './SearchResultsDetail.module.scss';
import { ShowhOcr, OpenLinkedDocument } from '../components';

interface ISearchResultsDetailProps {
    result: any;
    index: any;
    clickHandle: any;
    searchText: string;
}

export class SearchResultsDetail extends React.Component<ISearchResultsDetailProps, {}> {
    private _helpers: IHelper = new Helper();
    
    public render() {
        return (
            <div>
                {this.renderSearchResult()}
            </div>
        )
    }

    private renderSearchResult() {
        return (
            <div key={this.props.index} className={styles.searchResultsFlat}>
                <Container className={styles.searchResultsCard} key={this.props.index}>
                    <Grid container spacing={1} className={styles.grid} onClick={this.props.clickHandle}>
                        <Grid item xs={9} >
                            <div className={styles.tag}>{this.props.result.division}</div>
                            <div className={styles.title}>{this._helpers.ShowAllTitles(this.props.result.title)}</div>
                            <div className={styles.author}>{this.props.result.author}</div>
                        </Grid>
                        <Grid item xs={3}>
                            <div className={styles.date}>{this._helpers.FormatDate(this.props.result.contractDate)}</div>
                            {this.props.result.confidential ? <div className={styles.reversion}>Confidential</div> : <></>}
                        </Grid>
                    </Grid>
                    <Grid container spacing={1} onClick={this.props.clickHandle}>
                        <Grid item xs={9}>
                            <div className={styles.document}>
                                <ShowhOcr hOcrString={this.props.result.hOCRMetadata} searchText={this.props.searchText} title={this.props.result.title} />
                            </div>
                        </Grid>
                        <Grid item xs={3}>
                            <div className={styles.docTags}>
                                {this.props.result.documentType.length > 0 ? this.generateDocTags(this.props.result.documentType) : <></>}
                            </div></Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <div className={styles.linkedDocs}><OpenLinkedDocument relatedDocs={this.props.result.relatedKey} searchText={this.props.searchText} docId={this.props.result.id} title={this.props.result.title} /></div>
                        </Grid>
                    </Grid>
                </Container>
            </div>
        )
    }

    private generateDocTags(docs: any) {
        return docs.map((doc: any, index: any) => {
            return <Label key={index} ribbon='right' className={styles.docTag}>{doc}</Label>;
        });
    }
}
